import { useState, useEffect } from 'react';
import { X, Cookie, Check } from 'lucide-react';
import { Link } from 'react-router-dom';

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      essential: true, analytics: true, timestamp: new Date().toISOString()
    }));
    setVisible(false);
  };

  const handleRefuseOptional = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      essential: true, analytics: false, timestamp: new Date().toISOString()
    }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden">
        <div className="p-5 sm:p-6">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-xl bg-green-50 border border-green-100 flex items-center justify-center shrink-0">
              <Cookie className="w-5 h-5 text-green-600" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-base font-semibold text-foreground mb-1">Gestion des cookies</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Nous utilisons des cookies pour assurer le bon fonctionnement de la plateforme et, avec votre accord, pour mesurer son audience.
                Vous pouvez accepter ou refuser les cookies optionnels.{' '}
                <Link to="/confidentialite" className="text-green-600 underline" data-testid="cookie-privacy-link">
                  En savoir plus
                </Link>
              </p>

              {showDetails && (
                <div className="mt-4 space-y-3 text-sm">
                  <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                    <div>
                      <p className="font-medium text-foreground">Cookies essentiels</p>
                      <p className="text-xs text-muted-foreground">Authentification, securite, preferences. Necessaires au fonctionnement.</p>
                    </div>
                    <div className="flex items-center gap-1 text-green-600 text-xs font-medium">
                      <Check className="w-3.5 h-3.5" /> Toujours actif
                    </div>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                    <div>
                      <p className="font-medium text-foreground">Cookies analytiques</p>
                      <p className="text-xs text-muted-foreground">Mesure d'audience anonymisee pour ameliorer nos services.</p>
                    </div>
                    <span className="text-xs text-muted-foreground">Optionnel</span>
                  </div>
                </div>
              )}

              <div className="flex flex-wrap items-center gap-3 mt-4">
                <button
                  onClick={handleAcceptAll}
                  className="px-5 py-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-full transition-colors"
                  data-testid="cookie-accept-all"
                >
                  Tout accepter
                </button>
                <button
                  onClick={handleRefuseOptional}
                  className="px-5 py-2 bg-slate-100 hover:bg-slate-200 text-foreground text-sm font-medium rounded-full transition-colors"
                  data-testid="cookie-refuse-optional"
                >
                  Refuser les optionnels
                </button>
                <button
                  onClick={() => setShowDetails(!showDetails)}
                  className="px-4 py-2 text-sm text-muted-foreground hover:text-foreground transition-colors underline"
                  data-testid="cookie-show-details"
                >
                  {showDetails ? 'Masquer les details' : 'Personnaliser'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
